<div #mapContainer class="map-container"></div>
<p class="text-center"><i>On mobile? Pinch to zoom. On desktop? Scroll to zoom.</i>